<template>
  <ul class="pagination" v-show="totalPages > 1">
    <li class="page-item page-first" >
      <a style="padding: 12px;" class="page-link" @click="onClickFirstPage" v-if="totalPages>1" >
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z" />
        </svg>
      </a>
    </li>
    <li class="page-item page-first">
      <a style="padding: 12px;" class="page-link"  @click="onClickPreviousPage" v-if="totalPages>1" >
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
      </a>
    </li>

<li v-for="(item, page) in pages" :key="page" :class="['page-item',isPageActive(pages[page].name) ? 'active':null]" >
      <a class="page-link" @click="onClickPage(pages[page].name)" :disabled="pages[page].isDisabled"  >{{ pages[page].name }}</a>
    </li>

    <li class="page-item page-increment">
      <a style="padding: 12px;" class="page-link"   @click="onClickNextPage" v-if="totalPages>1"  >
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
        </svg>
      </a>
    </li>

    <li class="page-item page-last">
      <a style="padding: 12px;" class="page-link"   @click="onClickLastPage" v-if="totalPages>1"  >
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" />
        </svg>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  data(){
    return {
        //tempValue:this.value,
    }
  },
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 6
    },
    totalPages: {
      type: Number,
      required: true
    },
   /* total: {
      type: Number,
      required: true
    },*/
   /* perPage: {
      type: Number,
      required: true
    },*/
    /*currentPage: {
      type: Number,
      required: true
    },*/
    value:{

    },
  },
  watch:{
   /* value(newValue){
      //console.log(newValue,"this is new value");
    },*/
  },
  computed: {
    startPage() {
      if (this.value === 1) {
        return 1;
      }

      if (this.value === this.totalPages) {
        //console.log(this.totalPages - this.maxVisibleButtons + 1);
        if (this.totalPages>this.maxVisibleButtons)
        {
          return this.totalPages - this.maxVisibleButtons + 1;
        }
        return 1;

      }
      return this.value - 1;

    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
     // console.log("page in paginantion",this.value);
      const range = [];
      //console.log(this.startPage);
      for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
        range.push({
          name: i,
          isDisabled: i === this.value
        });
        //console.log(range);
      }
      return range;
    },
    isInFirstPage() {
      return this.value === 1;
    },
    isInLastPage() {
      return this.value === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('input', 1);
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      if(this.value>1)
        this.$emit('input', this.value - 1);
        this.$emit('pagechanged', this.value - 1);
    },
    onClickPage(page) {
      this.$emit('input', page);
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      if(this.value <this.totalPages) {
        this.$emit('input', this.value + 1);
        this.$emit('pagechanged', this.value + 1);
      }
    },
    onClickLastPage() {
      //this.value + 1
      this.$emit('input',this.totalPages );
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.value === page;
    },
  },
  mounted() {

  }
}
</script>

<style>
li{
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                              supported by Chrome, Edge, Opera and Firefox */
}
.page-item:first-child .page-link {
  margin-left: 15px !important;
}

/*// Extra small devices (portrait phones, less than 576px)*/
@media (max-width: 575.98px) {
  .page-first,.page-last,.page-increment,.page-decrement
  {
    display: none;
  }
}
/*// Small devices (landscape phones, 576px and up)*/
@media (min-width: 576px) and (max-width: 767.98px) {

}
/*// Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) and (max-width: 991.98px) {

}
/*// Large devices (desktops, 992px and up)*/
@media (min-width: 992px) and (max-width: 1199.98px) {
  .page-first,.page-last
  {
    display: none;
  }
}
/*// Extra large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {
  /*body{
    background: red;
  }*/
}

/*!* Extra small devices (phones, 600px and down) *!
@media only screen and (max-width: 600px) {

}

!* Small devices (portrait tablets and large phones, 600px and up) *!
@media only screen and (min-width: 600px) {

}

!* Medium devices (landscape tablets, 768px and up) *!
@media only screen and (min-width: 768px) {

}

!* Large devices (laptops/desktops, 992px and up) *!
@media only screen and (min-width: 992px) {
  .page-first,.page-last
  {
    display: none;
  }
}

!* Extra large devices (large laptops and desktops, 1200px and up) *!
@media only screen and (min-width: 1200px) {

}*/


/*.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}*/

/*
.active {
  background-color: #4AAE9B;
  color: #ffffff;
}
*/



</style>
